import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router";
import { Hidden } from "@mui/material";
import { connect } from "react-redux";

const MultiDrinkOptions = (props) => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const handleTest = () => {
    setOpen(true);
  };

  const handleYes = () => {
    setOpen(false);
    navigate("/menu");
  };

  const handleNo = () => {
    setOpen(false);
    navigate("/menu-summary");
  };

  return (
    <Dialog
      open={open}
      // onClose={handleNo}
    >
      <DialogTitle>Would you like to add another drink to your order?</DialogTitle>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={handleYes}>Yes</Button>
        <Button onClick={handleNo}>No</Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    order: state.order,
  };
};

export default connect(mapStateToProps)(MultiDrinkOptions);
